import { useTheme } from '@material-ui/core/styles';
import { Box, useMediaQuery } from '@material-ui/core';
import { useAppSelector } from '../reduxhooks';
import { ProductOnUser } from 'common-ts/dist/models/Product';
import React, { ReactNode } from 'react';
import PageElementSvg from './PageComponentElementSvg';
import PageElementProduct from './PageComponentElementProduct';
import PageElementCarousel from './PageComponentElementCarousel';
import BlockCollectionProducts from './PageComponentElementCollectionProducts';
import BlockTitledList from './PageComponentElementTitledList';
import BlockProductGallery from './PageComponentElementProductGallery';
import BlockProductTitlePrice from './PageComponentElementProductTitlePrice';
import BlockProductBuyBox from './PageComponentElementProductBuyBox';
import BlockProductDescription from './PageComponentElementProductDescription';
import BlockProductReviews from './PageComponentElementProductReviews';
import BlockProductRelated from './PageComponentElementProductRelated';

// This file includes the "block templates" for presentation.
// It does not code its own css and only functions as a compiler
// and an "example / template" builder for the API / components.
// It functions as a catalogue, and each code of UI block element
// from the backend corresponds to functions in this file.

// ALL THE BLOCK TEMPLATES HAS *NO STATE*, THEY ARE FULLY 
// MADE USING *PROPS* AND *REDUX STATE VARIABLES*.

interface BlockProps {
  elementContentJson: any
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  svgUrl: '.com',
})) 
*/
export interface BlockSvgBannerData {
  svgUrl: string
  linkTo?: string
}

export function BlockSvgBanner({elementContentJson} : BlockProps) {
  let elementContent: BlockSvgBannerData = elementContentJson;

  return (<PageElementSvg svg_url={elementContent.svgUrl} 
    linkTo={elementContent.linkTo ? elementContent.linkTo : undefined}/>);

  // return (
  //   <PageElementContainer
  //     margin={"0px"}
  //     content={[<PageElementSvg svg_url={elementContent.svgUrl} 
  //       linkTo={elementContent.linkTo ? elementContent.linkTo : undefined}/>]}
  //   />
  // );
}

export interface BlockInstantSizeTeamBannerData {
  svgUrl: string
}

export function BlockInstantSizeTeamBanner({elementContentJson} : BlockProps) {
  let elementContent: BlockInstantSizeTeamBannerData = elementContentJson;

  return null;

  // return (
  //   <PageElementContainer
  //     margin={"-20px 0px 60px 0px"}
  //     content={[<PageElementInstantSizeTeam svg_url={elementContent.svgUrl} />]}
  //   />
  // );
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  image_urls: ['.com', '.com'],
})) 
*/
export interface CarouselItemData {
  contentUrl: string
  contentType: "image" | "video-no-sound" | "video-with-sound"
  videoPoster?: string
  linkTo?: string
}
export interface BlockCarouselData {
  carouselItemDataArray: CarouselItemData[]
  linkTo?: string
}

export function BlockCarousel({elementContentJson} : BlockProps) {
  let elementContent: BlockCarouselData = elementContentJson;

  return (
    <PageElementCarousel 
      carouselItemDataArray={elementContent.carouselItemDataArray} 
      linkTo={elementContent.linkTo ? elementContent.linkTo : undefined}
      margin='0px'
    />
  );

  // return (
  //   <PageElementContainer
  //     margin={"0px"}
  //     content={[<PageElementCarousel 
  //       carouselItemDataArray={elementContent.carouselItemDataArray} 
  //       linkTo={elementContent.linkTo ? elementContent.linkTo : undefined}
  //     />]}
  //   />
  // );
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  productOneId: 'asd',
  productTwoId: 'fads',

  containerWidthXs: 'dfsaaf',
  containerWidthSm: 'fasdsf',
  containerWidthMd: '100%',
  containerWidthLg: '100%',
  productWidthXs: '100%',
  productWidthSm: '100%',
  productWidthMd: '100%',
  productWidthLg: '100%',

  containerMargin: '0px',
  productMargin: '0px',
  productPadding: '0px',
})) 
*/
export interface BlockTwoProductsCenterData {
  productOneId: string
  productOneImageUrl?: string
  productOneImageHoverUrl?: string
  productOneAdditionalImage?: string
  productTwoId: string
  productTwoImageUrl?: string
  productTwoImageHoverUrl?: string
  productTwoAdditionalImage?: string

  containerWidthXs: string
  containerWidthSm: string
  containerWidthMd: string
  containerWidthLg: string
  productWidthXs: string
  productWidthSm: string
  productWidthMd: string
  productWidthLg: string

  containerMargin?: string
  productMargin?: string
  productPadding?: string
}

export function BlockTwoProductsCenter({elementContentJson} : BlockProps) {
  let elementContent: BlockTwoProductsCenterData = elementContentJson;

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  let products = useAppSelector(state => state.productsList.productsDictionary);
  let productOne: ProductOnUser = products[elementContent.productOneId];
  let productTwo: ProductOnUser = products[elementContent.productTwoId];

  const productSizeAvailabilityDict = useAppSelector(state => state.productsList.productSizeAvailabilityDict);
  const numberOfItemsRemainingOne = productSizeAvailabilityDict?.[productOne.productId]?.numberOfItemsRemaining ?? 0;
  const isSoldOutOne = productOne.isSoldOut || 
  (window.location?.href?.includes("/plus-size") ? !productSizeAvailabilityDict?.[productOne.productId]?.availabilityArray?.[9] : numberOfItemsRemainingOne === 0);
  const numberOfItemsRemainingTwo = productSizeAvailabilityDict?.[productTwo.productId]?.numberOfItemsRemaining ?? 0;
  const isSoldOutTwo = productTwo.isSoldOut || 
  (window.location?.href?.includes("/plus-size") ? !productSizeAvailabilityDict?.[productTwo.productId]?.availabilityArray?.[9] : numberOfItemsRemainingTwo === 0);

  if (isSoldOutOne && isSoldOutTwo) {
    return null;
  }

  return (
    <Box style={{
      width: (isMdOrUp ? '100vw' : '100%'),
      justifyContent: (isMdOrUp ? 'center' : 'space-between'), 
      display: 'flex', 
      margin: '60px 0px 60px'}}>
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productOne.productId}
        image_url={elementContent.productOneImageUrl ? elementContent.productOneImageUrl : productOne.displayImage} 
        image_url_hover={elementContent.productOneImageHoverUrl ? elementContent.productOneImageHoverUrl : productOne.displayImageHover} 
        title={productOne.name}
        discountedPrice={productOne.discountedPrice}
        originalPrice={productOne.originalPrice}
        isSoldOut={productOne.isSoldOut}
        isComingAgainSoon={productOne.isComingAgainSoon}
        product_url={`/shop/product/` + productOne.productId} 
        marketplaceLinkData={productOne.marketplaceLinkData}
        image_additional_url={elementContent.productOneAdditionalImage}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productTwo.productId}
        image_url={elementContent.productTwoImageUrl ? elementContent.productTwoImageUrl : productTwo.displayImage} 
        image_url_hover={elementContent.productTwoImageHoverUrl ? elementContent.productTwoImageHoverUrl : productTwo.displayImageHover} 
        title={productTwo.name}
        discountedPrice={productTwo.discountedPrice}
        originalPrice={productTwo.originalPrice}
        isSoldOut={productTwo.isSoldOut}
        isComingAgainSoon={productTwo.isComingAgainSoon}
        product_url={`/shop/product/` + productTwo.productId} 
        marketplaceLinkData={productTwo.marketplaceLinkData}
        image_additional_url={elementContent.productTwoAdditionalImage}
      />
    </Box>);
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  productOneId: 'asd',
  productTwoId: 'fads',
  productThreeId: 'fads',

  containerWidthXs: 'dfsaaf',
  containerWidthSm: 'fasdsf',
  containerWidthMd: '100%',
  containerWidthLg: '100%',
  productWidthXs: '100%',
  productWidthSm: '100%',
  productWidthMd: '100%',
  productWidthLg: '100%',

  containerMargin: '0px',
  productMargin: '0px',
  productPadding: '0px',
})) 
*/
export interface BlockThreeProductsCenterData {
  productOneId: string
  productOneImageUrl?: string
  productOneImageHoverUrl?: string
  productTwoId: string
  productTwoImageUrl?: string
  productTwoImageHoverUrl?: string
  productThreeId: string
  productThreeImageUrl?: string
  productThreeImageHoverUrl?: string

  containerWidthXs: string
  containerWidthSm: string
  containerWidthMd: string
  containerWidthLg: string
  productWidthXs: string
  productWidthSm: string
  productWidthMd: string
  productWidthLg: string

  containerMargin?: string
  productMargin?: string
  productPadding?: string
}

export function BlockThreeProductsCenter({elementContentJson} : BlockProps) {
  let elementContent: BlockThreeProductsCenterData = elementContentJson;

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  let products = useAppSelector(state => state.productsList.productsDictionary);
  let productOne: ProductOnUser = products[elementContent.productOneId];
  let productTwo: ProductOnUser = products[elementContent.productTwoId];
  let productThree: ProductOnUser = products[elementContent.productThreeId];

  return (
    <Box style={{
      width: (isMdOrUp ? '100vw' : '100%'),
      justifyContent: (isMdOrUp ? 'center' : 'space-between'), 
      display: 'flex', 
      margin: '60px 0px 60px'}}>
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productOne.productId}
        image_url={elementContent.productOneImageUrl ? elementContent.productOneImageUrl : productOne.displayImage} 
        image_url_hover={elementContent.productOneImageHoverUrl ? elementContent.productOneImageHoverUrl : productOne.displayImageHover} 
        title={productOne.name}
        discountedPrice={productOne.discountedPrice}
        originalPrice={productOne.originalPrice}
        isSoldOut={productOne.isSoldOut}
        isComingAgainSoon={productOne.isComingAgainSoon}
        product_url={`/shop/product/` + productOne.productId} 
        marketplaceLinkData={productOne.marketplaceLinkData}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productTwo.productId}
        image_url={elementContent.productTwoImageUrl ? elementContent.productTwoImageUrl : productTwo.displayImage} 
        image_url_hover={elementContent.productTwoImageHoverUrl ? elementContent.productTwoImageHoverUrl : productTwo.displayImageHover} 
        title={productTwo.name}
        discountedPrice={productTwo.discountedPrice}
        originalPrice={productTwo.originalPrice}
        isSoldOut={productTwo.isSoldOut}
        isComingAgainSoon={productTwo.isComingAgainSoon}
        product_url={`/shop/product/` + productTwo.productId} 
        marketplaceLinkData={productTwo.marketplaceLinkData}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productThree.productId}
        image_url={elementContent.productThreeImageUrl ? elementContent.productThreeImageUrl : productThree.displayImage} 
        image_url_hover={elementContent.productThreeImageHoverUrl ? elementContent.productThreeImageHoverUrl : productThree.displayImageHover} 
        title={productThree.name}
        discountedPrice={productThree.discountedPrice}
        originalPrice={productThree.originalPrice}
        isSoldOut={productThree.isSoldOut}
        isComingAgainSoon={productThree.isComingAgainSoon}
        product_url={`/shop/product/` + productThree.productId} 
        marketplaceLinkData={productThree.marketplaceLinkData}
      />
    </Box>
  );
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  productOneId: 'asd',
  productTwoId: 'fads',
  productThreeId: 'fads',
  productFourId: 'fads',

  containerWidthXs: 'dfsaaf',
  containerWidthSm: 'fasdsf',
  containerWidthMd: '100%',
  containerWidthLg: '100%',
  productWidthXs: '100%',
  productWidthSm: '100%',
  productWidthMd: '100%',
  productWidthLg: '100%',

  containerMargin: '0px',
  productMargin: '0px',
  productPadding: '0px',
})) 
*/
export interface BlockFourProductsCenterData {
  productOneId: string
  productOneImageUrl?: string
  productOneImageHoverUrl?: string
  productTwoId: string
  productTwoImageUrl?: string
  productTwoImageHoverUrl?: string
  productThreeId: string
  productThreeImageUrl?: string
  productThreeImageHoverUrl?: string
  productFourId: string
  productFourImageUrl?: string
  productFourImageHoverUrl?: string

  containerWidthXs: string
  containerWidthSm: string
  containerWidthMd: string
  containerWidthLg: string
  productWidthXs: string
  productWidthSm: string
  productWidthMd: string
  productWidthLg: string

  containerMargin?: string
  productMargin?: string
  productPadding?: string
}

export function BlockFourProductsCenter({elementContentJson} : BlockProps) {
  let elementContent: BlockFourProductsCenterData = elementContentJson;

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  let products = useAppSelector(state => state.productsList.productsDictionary);
  let productOne: ProductOnUser = products[elementContent.productOneId];
  let productTwo: ProductOnUser = products[elementContent.productTwoId];
  let productThree: ProductOnUser = products[elementContent.productThreeId];
  let productFour: ProductOnUser = products[elementContent.productFourId];

  return (
    <Box style={{
      width: (isMdOrUp ? '100vw' : '100%'),
      justifyContent: (isMdOrUp ? 'center' : 'space-between'), 
      display: 'flex', 
      margin: '60px 0px 60px'}}>
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productOne.productId}
        image_url={elementContent.productOneImageUrl ? elementContent.productOneImageUrl : productOne.displayImage} 
        image_url_hover={elementContent.productOneImageHoverUrl ? elementContent.productOneImageHoverUrl : productOne.displayImageHover} 
        title={productOne.name}
        discountedPrice={productOne.discountedPrice}
        originalPrice={productOne.originalPrice}
        isSoldOut={productOne.isSoldOut}
        isComingAgainSoon={productOne.isComingAgainSoon}
        product_url={`/shop/product/` + productOne.productId} 
        marketplaceLinkData={productOne.marketplaceLinkData}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productTwo.productId}
        image_url={elementContent.productTwoImageUrl ? elementContent.productTwoImageUrl : productTwo.displayImage} 
        image_url_hover={elementContent.productTwoImageHoverUrl ? elementContent.productTwoImageHoverUrl : productTwo.displayImageHover} 
        title={productTwo.name}
        discountedPrice={productTwo.discountedPrice}
        originalPrice={productTwo.originalPrice}
        isSoldOut={productTwo.isSoldOut}
        isComingAgainSoon={productTwo.isComingAgainSoon}
        product_url={`/shop/product/` + productTwo.productId} 
        marketplaceLinkData={productTwo.marketplaceLinkData}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productThree.productId}
        image_url={elementContent.productThreeImageUrl ? elementContent.productThreeImageUrl : productThree.displayImage} 
        image_url_hover={elementContent.productThreeImageHoverUrl ? elementContent.productThreeImageHoverUrl : productThree.displayImageHover} 
        title={productThree.name}
        discountedPrice={productThree.discountedPrice}
        originalPrice={productThree.originalPrice}
        isSoldOut={productThree.isSoldOut}
        isComingAgainSoon={productThree.isComingAgainSoon}
        product_url={`/shop/product/` + productThree.productId} 
        marketplaceLinkData={productThree.marketplaceLinkData}
      />
      <PageElementProduct 
        width={isMdOrUp ? '21.3vw' : '48vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : (isMdOrUp ? '0px 6px' : undefined)}
        product_id={productFour.productId}
        image_url={elementContent.productFourImageUrl ? elementContent.productFourImageUrl : productFour.displayImage} 
        image_url_hover={elementContent.productFourImageHoverUrl ? elementContent.productFourImageHoverUrl : productFour.displayImageHover} 
        title={productFour.name}
        discountedPrice={productFour.discountedPrice}
        originalPrice={productFour.originalPrice}
        isSoldOut={productFour.isSoldOut}
        isComingAgainSoon={productFour.isComingAgainSoon}
        product_url={`/shop/product/` + productFour.productId} 
        marketplaceLinkData={productFour.marketplaceLinkData}
      />
    </Box>
  );
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  productIds: ['asd','bcd'],

  containerWidthXs: 'dfsaaf',
  containerWidthSm: 'fasdsf',
  containerWidthMd: '100%',
  containerWidthLg: '100%',
  productWidthXs: '100%',
  productWidthSm: '100%',
  productWidthMd: '100%',
  productWidthLg: '100%',

  containerMargin: '0px',
  productMargin: '0px',
  productPadding: '0px',
})) 
*/
export interface BlockProductArrayCenterData {
  productIds: string[]

  containerWidthXs: string
  containerWidthSm: string
  containerWidthMd: string
  containerWidthLg: string
  productWidthXs: string
  productWidthSm: string
  productWidthMd: string
  productWidthLg: string

  containerMargin?: string
  productMargin?: string
  productPadding?: string
}

export function BlockProductArrayCenter({elementContentJson} : BlockProps) {
  let elementContent: BlockProductArrayCenterData = elementContentJson;

  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  // Classic responsive grid: the per-breakpoint widths in the content JSON
  // (e.g. 48% => two columns on mobile, 30% => three on desktop).
  const productWidth =
    (isLg ? elementContent.productWidthLg : isMd ? elementContent.productWidthMd :
      isSm ? elementContent.productWidthSm : elementContent.productWidthXs) ?? '48%';
  const containerWidth =
    (isLg ? elementContent.containerWidthLg : isMd ? elementContent.containerWidthMd :
      isSm ? elementContent.containerWidthSm : elementContent.containerWidthXs) ?? '100%';

  let products = useAppSelector(state => state.productsList.productsDictionary);

  let contentArray: JSX.Element[] = [];
  for (let i = 0; i < elementContent.productIds.length; i++) {
    let product = products[elementContent.productIds[i]];
    // Skip ids not present in the loaded catalog (deleted/unpublished
    // products referenced by a stored layout, or catalog still loading).
    if (!product) {
      continue;
    }
    contentArray.push(
      <PageElementProduct
        key={product.productId}
        width={productWidth}
        product_id={product.productId}
        image_url={product.displayImage}
        image_url_hover={product.displayImageHover}
        title={product.name}
        discountedPrice={product.discountedPrice}
        originalPrice={product.originalPrice}
        isSoldOut={product.isSoldOut}
        isComingAgainSoon={product.isComingAgainSoon}
        product_url={`/shop/product/` + product.productId}
        margin={elementContent.productMargin ? elementContent.productMargin : undefined}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        marketplaceLinkData={product.marketplaceLinkData}
      />
    );
  }

  return (
    <Box style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Box style={{
        width: containerWidth,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        margin: elementContent.containerMargin ? elementContent.containerMargin : undefined,
      }}>
        {contentArray}
      </Box>
    </Box>
  );
}

/*
GENERATOR CODE. Use in Chrome browser to generate string.
a = (JSON.stringify({
  productOneId: 'asd',

  containerWidthXs: 'dfsaaf',
  containerWidthSm: 'fasdsf',
  containerWidthMd: '100%',
  containerWidthLg: '100%',
  productWidthXs: '100%',
  productWidthSm: '100%',
  productWidthMd: '100%',
  productWidthLg: '100%',

  containerMargin: '0px',
  productMargin: '0px',
  productPadding: '0px',
})) 
*/
export interface BlockOneProductCenterData {
  productOneId: string
  productOneImageUrl?: string
  productOneImageHoverUrl?: string
  productOneAdditionalImage?: string

  productWidthXs: string
  productWidthSm: string
  productWidthMd: string
  productWidthLg: string

  containerMargin?: string
  productMargin?: string
  productPadding?: string
}

export function BlockOneProductCenter({elementContentJson} : BlockProps) {
  let elementContent: BlockOneProductCenterData = elementContentJson;

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  let products = useAppSelector(state => state.productsList.productsDictionary);
  let productOne: ProductOnUser = products[elementContent.productOneId];

  const productSizeAvailabilityDict = useAppSelector(state => state.productsList.productSizeAvailabilityDict);
  const numberOfItemsRemainingOne = productSizeAvailabilityDict?.[productOne.productId]?.numberOfItemsRemaining ?? 0;
  const isSoldOutOne = productOne.isSoldOut || 
  (window.location?.href?.includes("/plus-size") ? !productSizeAvailabilityDict?.[productOne.productId]?.availabilityArray?.[9] : numberOfItemsRemainingOne === 0);

  if (isSoldOutOne) {
    return null;
  }

  return (
    <Box style={{
      width: (isMdOrUp ? '100vw' : '100%'),
      justifyContent: 'center', 
      display: 'flex', 
      margin: '60px 0px 60px'}}>
      <PageElementProduct 
        width={isMdOrUp ? '24vw' : '75vw'}
        padding={elementContent.productPadding ? elementContent.productPadding : undefined}
        margin={elementContent.productMargin ? elementContent.productMargin : undefined}
        product_id={productOne.productId}
        image_url={elementContent.productOneImageUrl ? elementContent.productOneImageUrl : productOne.displayImage} 
        image_url_hover={elementContent.productOneImageHoverUrl ? elementContent.productOneImageHoverUrl : productOne.displayImageHover} 
        title={productOne.name}
        discountedPrice={productOne.discountedPrice}
        originalPrice={productOne.originalPrice}
        isSoldOut={productOne.isSoldOut}
        isComingAgainSoon={productOne.isComingAgainSoon}
        product_url={`/shop/product/` + productOne.productId} 
        marketplaceLinkData={productOne.marketplaceLinkData}
        image_additional_url={elementContent.productOneAdditionalImage}
      />
    </Box>
  );
}

//
// RENDERER
// This is the core renderer function to get a JSX element from
// a code and content json.
//
export interface RenderBlockElementProps {
  code: string
  contentJson: any
  children?: ReactNode
}

export const RenderBlockElement = React.memo(function RenderBlockElement({code, contentJson}: RenderBlockElementProps) {
  var contentJsonParsed;
  if (typeof contentJson === 'string' || contentJson instanceof String) {
    contentJsonParsed = JSON.parse(contentJson.toString());
  } else {
    contentJsonParsed = contentJson;
  }

  switch (code) {
    case 'BlockSvgBanner':
      return (
        <BlockSvgBanner elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockInstantSizeTeamBanner':
    return (
      <BlockInstantSizeTeamBanner elementContentJson={contentJsonParsed} />
    )
    break;
    case 'BlockCarousel':
      return (
        <BlockCarousel elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockTwoProductsCenter':
      return (
        <BlockTwoProductsCenter elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockThreeProductsCenter':
      return (
        <BlockThreeProductsCenter elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockFourProductsCenter':
      return (
        <BlockFourProductsCenter elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockOneProductCenter':
      return (
        <BlockOneProductCenter elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockProductArrayCenter':
      return (
        <BlockProductArrayCenter elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockCollectionProducts':
      return (
        <BlockCollectionProducts elementContentJson={contentJsonParsed} />
      )
      break;
    case 'BlockTitledList':
      return (
        <BlockTitledList elementContentJson={contentJsonParsed} />
      )
      break;
    // Product-page blocks. Each reads ProductPageContext and renders null
    // outside a product page, so dropping one into a Kategori or Halaman
    // layout degrades quietly instead of crashing.
    case 'BlockProductGallery':
      return (
        <BlockProductGallery content={contentJsonParsed} />
      )
      break;
    case 'BlockProductTitlePrice':
      return (
        <BlockProductTitlePrice content={contentJsonParsed} />
      )
      break;
    case 'BlockProductBuyBox':
      return (
        <BlockProductBuyBox content={contentJsonParsed} />
      )
      break;
    case 'BlockProductDescription':
      return (
        <BlockProductDescription content={contentJsonParsed} />
      )
      break;
    case 'BlockProductReviews':
      return (
        <BlockProductReviews content={contentJsonParsed} />
      )
      break;
    case 'BlockProductRelated':
      return (
        <BlockProductRelated content={contentJsonParsed} />
      )
      break;
  }
  return (<Box></Box>);
}, ((prevProps, nextProps) => 
  prevProps.code === nextProps.code && prevProps.contentJson === nextProps.contentJson)
);
